module.exports = __webpack_public_path__ + "img/banner-media.cda3e75b.png";